import { render, staticRenderFns } from "./AgregateSum.vue?vue&type=template&id=ffc2aa48&"
import script from "./AgregateSum.vue?vue&type=script&lang=js&"
export * from "./AgregateSum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports